(ns ui.gallery.prompt-modal
  "A Replicant replacement of `js/prompt` for the folder names of the
   gallery (`js/prompt` shows the full URL with the organization uuid,
   and its input is barely visible on macOS Chrome). Modal `:params`:

   - `:title` the question
   - `:value` the initial value (the current name for a rename)
   - `:on-submit` an action vector that gets the entered text appended,
     e.g. `[:gallery/folder-rename uuid]`"
  (:require [clojure.string :as str]
            [storrito.ui.button :as button]))

(def max-name-length
  ;; the same limit as `storrito.gallery.folder-shared/max-name-length`:
  512)

(defn render
  [state]
  (let [{:keys [title]} (get-in state [:ui/modal :params])
        value (or (get-in state [:gallery :prompt-value]) "")
        too-long? (< max-name-length (count value))]
    [:form
     {:on {:submit [[:js/prevent-default]
                    [:gallery/prompt-submit]]}}
     [:h2.text-lg.font-semibold.text-gray-900.mb-3
      title]
     [:input.w-full.bg-white.border.border-gray-400.rounded.text-gray-800.shadow-sm.px-3.py-2.mb-1
      {:type "text"
       :value value
       :aria-label title
       :replicant/on-mount (fn [{:keys [replicant/node]}]
                             (.focus node)
                             (.select node))
       :on {:input [[:store/assoc-in [:gallery :prompt-value] :event/target.value]]}}]
     [:p.text-xs.mb-4
      {:class (if too-long? "text-red-600" "text-gray-500")}
      (str "Up to " max-name-length " characters.")]
     [:div.flex.gap-2.justify-end
      [:button
       {:class button/button-cancel-css
        :type "button"
        :on {:click [[:ui/modal-close]]}}
       "Cancel"]
      [:button
       {:class button/button-primary-css
        :type "submit"
        :disabled (or (str/blank? value)
                      too-long?)}
       "OK"]]]))

(def modal
  {:modal-id :modals/gallery-prompt
   :on-load (fn [state]
              [[:store/assoc-in [:gallery :prompt-value]
                (or (get-in state [:ui/modal :params :value]) "")]])
   :render #'render})
